import { Typography } from "@material-ui/core"

const Base = (props) => {

  return ( <>
    <Typography>
      For $99, you get the full VIP treatment—minus the overpriced bottle service. This includes a one-on-one video chat with a lyricist to craft your song’s story, a custom set of lyrics delivered within 48 hours, up to five rounds of revisions to make it just right, and a professionally recorded song in your chosen style. Basically, everything you need to turn your story into a song that sounds like it belongs on a playlist called <i>Absolute Bangers</i>.
    </Typography>
  </> )
}

export default Base
